import Vue from 'vue'
import App from './search/Search.vue'

Vue.config.productionTip = false

new Vue({
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/serp.js